import { render, staticRenderFns } from "./ReportHistoryTable.vue?vue&type=template&id=79a84fb6&scoped=true&"
import script from "./ReportHistoryTable.vue?vue&type=script&lang=js&"
export * from "./ReportHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportHistoryTable.vue?vue&type=style&index=0&id=79a84fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a84fb6",
  null
  
)

export default component.exports